import { ContentfulImageAPIParams } from '@cibo/core'
import { Asset } from 'contentful'
import { FC } from 'react'
import { BackgroundImage } from '..'
import { BackgroundImageProps } from './BackgroundImage'

const ALPHA_TYPES = ['image/png', 'image/svg+xml']
interface ContentfulBackgroundImageProps {
  preferTransparency?: boolean
}

export const ContentfulBackgroundImage: FC<
  ContentfulBackgroundImageProps &
    ContentfulImageAPIParams &
    Omit<BackgroundImageProps, 'url'> &
    Pick<Asset, 'fields'>
> = ({
  behavior,
  fields,
  format,
  focusArea,
  height,
  preferTransparency,
  quality,
  width,
  ...rest
}) => {
  const params = new URLSearchParams()

  if (!fields?.file || fields.file.url.includes('downloads')) return null

  params.set(
    'fm',
    format
      ? format
      : preferTransparency
      ? ALPHA_TYPES.includes(fields.file.contentType)
        ? 'png'
        : 'jpg'
      : 'jpg'
  )
  behavior !== undefined && params.set('fit', behavior)
  focusArea !== undefined && params.set('f', focusArea)
  height !== undefined && params.set('h', `${height}`)
  width !== undefined && params.set('w', `${width}`)
  quality !== undefined && params.set('q', `${quality}`)

  return (
    <BackgroundImage
      url={`${fields.file.url}?${params.toString()}`}
      height={height}
      width={width}
      {...rest}
    />
  )
}
